import { JSX, useContext } from "react";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";

const ExcessWarningsDescription = (): JSX.Element => {
  const ffContext = useContext(FeatureFlagContext);
  const countingUpdatesEnabled = ffContext.enabledFeatureFlags.has(Features.EXCESS_WARNINGS_COUNTING_UPDATES);

  if (countingUpdatesEnabled) {
    return <>
      <p>
        Excess warnings indicate an over-representation of a provider within the data.
        Identifying providers with excessive representation within the data helps spot patterns that can point to data management issues, data source issues, or inconsistencies in how provider records are captured across internal systems.
      </p>
      <p>
        Excess warnings themselves do not differentiate between the overall validity of a specific record but instead flag all instances of provider records that meet the excessive thresholds.
      </p>
      <p>
        Measures of excessiveness are calculated and counted by <b>unique NPI</b>.
      </p>
      <p>
        Each warning is labeled with the provider’s NPI type, sourced from NPPES. NPIs not found in NPPES or without a valid Entity Type will not be counted.
      </p>
      <p>
        When navigating from the card to viewing the breakdown of addresses or specialties, the full breakdown will always be displayed to ensure reporting functionality exists for users who may want to include providers that fall into more than one of the pre-determined buckets.
      </p>
      <p>
        <i>Note: Excess Specialties is limited to only those specialty codes included in the QES® Adequacy specialty template, meaning providers with specialty codes not included in the template will not count towards the count of excessiveness.</i>
      </p>
      <p>
        <i>Note: Excess Addresses uses a count of latitude/longitude as the representation of address to avoid issues where slight discrepancies in the address could result in the over-counting of addresses.</i>
      </p>
    </>;
  }

  return <>
    <p>
      Excess warnings indicate an over-representation of a provider within the data.
      Excess warnings themselves do not differentiate between the overall validity of a specific record but instead flag all instances of provider records that meet the excessive thresholds.
    </p>
    <p>
      Calculated and counted by <b>unique NPI</b>.
    </p>
    <p>
      Identifying providers with excessive representation within the data helps spot patterns that can point to data management issues, data source issues, or inconsistencies in how provider records are captured across internal systems.
    </p>
    <p>
      When navigating from the card to viewing the breakdown of addresses or specialties, the full breakdown will always be displayed to ensure reporting functionality exists for users who may want to include providers that fall into more than one of the pre-determined buckets.
    </p>
    <p>
      <i>Note: Excess Specialties is limited to only those specialty codes included in the QES® Adequacy specialty template, meaning providers with specialty codes not included in the template will not count towards the count of excessiveness.</i>
    </p>
    <p>
      <i>Note: Excess Addresses uses a count of latitude/longitude as the representation of address to avoid issues where slight discrepancies in the address could result in the over-counting of addresses.</i>
    </p>
  </>;
}

export { ExcessWarningsDescription };
